import { render } from "./BtnGooglePay.vue?vue&type=template&id=3c0574de"
import script from "./BtnGooglePay.vue?vue&type=script&lang=js"
export * from "./BtnGooglePay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__